import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function CategoryCard({ title, description, image, slug, compact = false }) {
  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="flex flex-col overflow-hidden rounded-none bg-white border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 h-full"
    >
      <div className={`flex-shrink-0 ${compact ? 'h-80 sm:h-96' : 'h-[450px] sm:h-[500px]'} overflow-hidden`}>
        <img className="h-full w-full object-cover transition-transform duration-500 hover:scale-110" src={image} alt={title} />
      </div>
      <div className={`flex flex-1 flex-col justify-between ${compact ? 'p-6' : 'p-8'}`}>
        <div className="flex-1">
          <h3 className={`${compact ? 'text-lg' : 'text-xl'} font-bold text-[#1e335e] uppercase`}>{title}</h3>
          <div 
            className={`mt-3 ${compact ? 'text-sm' : 'text-base'} text-gray-500 line-clamp-2`}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        <div className="mt-6">
          <Link
            to={`/kategori/${slug}`}
            className="inline-flex items-center text-sm font-semibold text-gray-900 hover:text-orange-500 transition-colors"
          >
            Se udvalg
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
